import { render, staticRenderFns } from "./CbsActiveSessions.vue?vue&type=template&id=91657fb4"
import script from "./CbsActiveSessions.vue?vue&type=script&lang=js"
export * from "./CbsActiveSessions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports